import { styled, Text, useTranslation } from '@obvio/app'
import { SvgPlus } from '@obvio/svg'
import { AggregateData, Button, HiddenInput, Stack } from '@obvio/ui'
import { useState } from 'react'

import { FormArtworkInner } from './FormArtworkInner'
import { FormArtworksList } from './FormArtworskList'
import { FormContinue } from './FormContinue'

import type { Dict } from '@obvio/utils'
import type { ReactElement } from 'react'

const AddMoreButton = styled(Button)`
  margin-top: ${(theme) => theme.spacing.medium};
`

function aggregateMultiple(data: Dict<string>) {
  return Object.values(data).filter(Boolean)
}

export function FormArtworks(): ReactElement {
  const { t } = useTranslation()
  const [adding, setAdding] = useState<boolean>(false)

  const close = () => setAdding(false)

  return (
    <AggregateData name="artworks" aggregate={aggregateMultiple}>
      <HiddenInput name="artworks-hidden" optional />
      <Stack kind="vertical">
        <FormArtworksList />
        {adding ? (
          <FormArtworkInner close={close} />
        ) : (
          (null as unknown as ReactElement)
        )}
        <AddMoreButton
          onClick={() => setAdding(true)}
          kind="ghost"
          disabled={adding}
        >
          <Stack>
            <SvgPlus />
            <Text tag="span">{t('joinForm.addArtwork')}</Text>
          </Stack>
        </AddMoreButton>
        <FormContinue />
      </Stack>
    </AggregateData>
  )
}
